import Vue from 'vue';
import Vuex from 'vuex';
import state from './state';
import mutations from './mutations';
import actions from './actions';
import getters from './getters';

// IMPORT MODULES
import auth from './modules/auth';
import gapi from './modules/gapi';
import navigation from './modules/navigation';
import dashboard from './modules/dashboard';
import customers from './modules/contacts';
import shipments from './modules/shipments';
import invoices from './modules/finance/invoices';
import invoiceItems from './modules/finance/invoices/items'
import settings from './modules/settings';
import connect from './modules/connect';
import filter from './modules/filter';
import addressSearch from './modules/addressSearch';
import reports from './modules/reports';
import items from './modules/items';
import pickups from './modules/pickups';

Vue.use(Vuex);

export default new Vuex.Store({
  state,
  mutations,
  actions,
  getters,
  modules: {
    user: auth,
    navigation,
    dashboard,
    customers,
    invoices,
    invoiceItems,
    shipments,
    settings,
    filter,
    connect,
    gapi,
    addressSearch,
    reports,
    items,
    pickups
  },
});
